export default "__VITE_ASSET__BdPz4z2y__"